.portal-tooltip {
    max-width: 300px;
    white-space: 'normal';
    word-wrap: 'break-word';
    overflow-wrap: break-word;
    z-index: 9999;
}
